import { render, staticRenderFns } from "./CategoriesListItem.vue?vue&type=template&id=6830a46c&"
import script from "./CategoriesListItem.vue?vue&type=script&lang=js&"
export * from "./CategoriesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports